export default __webpack_public_path__ + "static/media/cadillac.a3af6caa.svg";